import type { IconButtonProps as DesignSystemIconButtonProps } from "@/design-system/IconButton";
import {
  IconButton as DesignSystemIconButton,
  iconButtonVariants as designSystemIconButtonVariants,
} from "@/design-system/IconButton";

export type IconButtonProps = DesignSystemIconButtonProps;
export const IconButton = DesignSystemIconButton;
export const iconButtonVariants = designSystemIconButtonVariants;
